import { app } from "./serviceLMS";
import { ADD_USER_TO_GROUP, CREATE_GROUP, DELETE_GROUP, DELETE_SINGLE_USER, GET_ALL_GROUPS, GET_COURSE_DETAILS, GET_COURSE_NAME_DETAILS, GET_USER_BUNDLES_IN_GROUP, GET_USER_COURSES_IN_GROUP, GET_USER_GROUPS, GET_USERS_IN_GROUP, UPDATE_GROUP } from "./URLs";


export const getAllGroups = async (
  page,
  size,
  isActive,
  searchText,
) => {
  try {
    const response = await app.get(GET_ALL_GROUPS, {
     params: {
        page: page,          
        size: size,         
        sortBy: "groupId",     
        sortDir: "desc",          
        active: isActive ?? null,  
        search: searchText || undefined, 
      },
    });
    if (response.status === 200 || response.status === 201) {
      console.log("reponse",response.data);
      return { success: true, data: response.data };
     
    } else {
      return { success: false, data: "Failed to fetch groups." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching groups." };
  }
};

export const addGroup = async (group) => {
  try {
    const response = await app.post(CREATE_GROUP, group);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to add group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error adding group." };
  }
};

export const updateGroup = async (group) => {
  try {
    const response = await app.put(UPDATE_GROUP, group);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to update group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error updating group." };
  }
};

export const deleteGroup = async (groupId) => {
  try {
    const response = await app.delete(DELETE_GROUP(groupId));
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to delete group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error deleting group." };
  }
};

export const getUsersInGroup = async (groupId, page = 0, size = 10, search) => {
  try {
    const response = await app.get(GET_USERS_IN_GROUP(groupId), {
      params: { page, size, sortDir: "DESC", active: true, search },
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch users in group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching users in group." };
  }
};

export const deleteSingleUser = async (user) => {
  try {
    const response = await app.delete(DELETE_SINGLE_USER, { data: user });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to delete user." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error deleting user." };
  }
};

export const addUser = async (user) => {
  try {
    const response = await app.post(ADD_USER_TO_GROUP, user);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to add user to group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error adding user to group." };
  }
};

export const getCourseDetails = async (groupId) => {
  try {
    const response = await app.get(GET_COURSE_DETAILS(groupId));
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch course details." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching course details." };
  }
};

export const getCourseNameDetails = async (groupId) => {
  try {
    const response = await app.get(GET_COURSE_NAME_DETAILS(groupId));
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch course name details." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching course name details." };
  }
};

export const getUserCoursesInGroup = async (group) => {
  try {
    const response = await app.post(GET_USER_COURSES_IN_GROUP, group);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to fetch user courses in group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching user courses in group." };
  }
};

export const getUserBundlesInGroup = async (group) => {
  try {
    const response = await app.post(GET_USER_BUNDLES_IN_GROUP, group);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to fetch user bundles in group." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching user bundles in group." };
  }
};

export const getUserGroups = async (page, size) => {
  try {
    const response = await app.get(GET_USER_GROUPS, {
      params: { page, size },
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: "Failed to fetch user groups." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching user groups." };
  }
};

